<script lang="ts">
  export default {
    name: 'ProgramsCollapseView',
  }
</script>

<script setup lang="ts">
import { RuleViolatingProgram } from '@/services/v2/ClientReadinessService';
import { EllipsisVertical } from '@lucide/vue';


defineProps<{
  title: string;
  programs: RuleViolatingProgram[];
  actions: {label: string, value: string}[];
}>();

const emit = defineEmits<{
  action: [action: string, programId: number];
}>();

</script>

<template>
  <div
    class="collapse collapse-arrow overflow-visible rounded-lg bg-base-200 text-lg"
    :class="{ 'collapse-close': programs.length === 0 }"
  >
    <input type="checkbox" />
    <div class="collapse-title flex justify-between">
      <div>{{ title }}</div>
      <div class="text-xl" :class="{ 'text-primary': programs.length > 0 }">
        {{ programs.length }}
      </div>
    </div>
    <div class="collapse-content">
      <table class="table bg-white">
        <tbody>
          <tr v-for="program in programs" :key="program.programId">
            <td>
              <div class="flex items-center gap-2">
                <div class="text-base">
                  {{ program.programName }}
                </div>
              </div>
            </td>
            <td class="text-end">
              <div v-if="actions.length > 0" class="dropdown">
                <div tabindex="0" role="button" class="btn btn-xs">
                  <EllipsisVertical :size="15" />
                </div>
                <ul
                  tabindex="0"
                  class="menu dropdown-content menu-xs z-10 rounded-lg bg-white shadow"
                >
                  <li v-for="action in actions" :key="action.value">
                    <a @click="emit('action', action.value, program.programId)">{{ action.label }}</a>
                  </li>
                </ul>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
